module.exports = __webpack_public_path__ + "img/wawa3_slide_1.1a1b84c3.jpg";